module.exports = __webpack_public_path__ + "img/ypost2.31905df1.png";